export default __webpack_public_path__ + "static/03-01-analyse-review-work-7d6c4f948a2d210688af9a00a86c533f.gif";